import i1 from "../img/i1.png";
import f1 from "../img/f1.png";
import c7 from "../img/c7.png";
import cu3 from "../img/cu3.png";

export const heroData = [
  {
    id: 1,
    name: "Es Krim",
    img: i1,
    desc: "Es Krim Cokelat",
    price: 4,
  },
  {
    id: 2,
    name: "Stroberi",
    img: f1,
    desc: "Stroberi Segar",
    price: 0.5,
  },
  {
    id: 3,
    name: "Ayam Goreng",
    img: c7,
    desc: "3 Potong Paha Ayam",
    price: 10,
  },
  {
    id: 4,
    name: "Sup Udang",
    img: cu3,
    desc: "Sup Udang Krimi",
    price: 10,
  },
];

export const categories = [
  {
    id: 1,
    name: "Ayam",
    urlParamName: "chicken",
  },
  {
    id: 2,
    name: "Kari",
    urlParamName: "curry",
  },
  {
    id: 3,
    name: "Nasi",
    urlParamName: "rice",
  },
  {
    id: 4,
    name: "Laut",
    urlParamName: "seafood",
  },
  {
    id: 5,
    name: "Buah",
    urlParamName: "fruits",
  },
  {
    id: 6,
    name: "Es Krim",
    urlParamName: "icecreams",
  },
  {
    id: 7,
    name: "Minuman",
    urlParamName: "drinks",
  },
];
